module.exports = __webpack_public_path__ + "img/worksbot_img19112802.8395b1d8.jpg";